import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import { formatAddress, formatInscriptionId } from '../../util/format-data';
import { amountFormat } from '../../util/format-data';
import { getMarketplaceData, getMarketplacePsbt, saveMarketplaceData, savePointData } from '../../util/api';
import { useSelector } from 'react-redux';
import { useWallets } from '@wallet-standard/react';
import { getSignedPsbt } from '../../util/api';
import { BitcoinNetworkType, signMessage, signTransaction, sendBtcTransaction } from 'sats-connect';
import { launchpadTokenRandom } from '../../util/new-api';
import { dust20MarketplaceFeeLimit, marketplaceFeeRate } from '../../configs/constant';
import { 
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Spinner,
} from "@material-tailwind/react";
import toast, { Toaster } from 'react-hot-toast';
import { CheckIcon, PlusIcon } from '@heroicons/react/24/outline';

export default function Dust20TransferCard(props) {
  const { data,  handle } = props;

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    handle(checked, data);
  }, [checked])

  const { t, i18n } = useTranslation();
  return (
    <div className="flex flex-col justify-center items-center gap-2 border-borderColor border-[1px] border-solid bg-gray-900 p-5 rounded-md w-full min-w-[200px]">
      <div className="flex flex-row justify-between items-center p-1 w-full">
        <div className="font-bold pl-1">{data.tick.toUpperCase()}</div>
        {
          checked ?
          <CheckIcon strokeWidth={2} className="h-6 w-6 bg-primary text-white p-1 rounded-full hover:bg-primary-hover cursor-pointer" onClick={() => {setChecked(false)}}/>
          :
          <PlusIcon strokeWidth={2} className="h-6 w-6 bg-gray-700 text-white p-1 rounded-full hover:text-primary cursor-pointer" onClick={() => {setChecked(true)}}/>
        }
      </div>
      <div>{t('Amount')}: {amountFormat(data.amount)}</div>
      <a href={`https://mempool.space/tx/${data.txId}`} target="_blank" rel="noopener noreferrer">
        <div className="cursor-pointer">{formatAddress(data.output)}</div>
      </a>
    </div>
  )
}
